import React from 'react';
import {
  airbnb,
  crypto,
  diamant,
  instagram,
  ishare,
  medium,
  metaverse,
  mafia,
  twitter,
  bgHome,
  rntinsta,
} from '../images/images';

const Rule = ({ color }) => (
  <hr
    style={{
      borderColor: color,
    }}
  />
);

const Middle = () => {
  return (
    <>
      {' '}
      <div className="w3-col m7 middle_all">
        <div className="w3-row-padding">
          <div className="w3-col m12">
            <div className="w3-card w3-round w3-white">
              <div className="w3-container w3-padding middle">
                <h6 className="title__middle">Projects</h6>
                <a href="#projects">
                  <button type="button" className="btn__middle">
                    <i className="fa fa-eye" aria-hidden="true"></i> See
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="w3-container w3-card w3-white w3-round w3-margin"
          id="projects"
        >
          <h4 className="project_one">I-SHARE</h4>

          <Rule color="#49a6e9" />
          <p className="description">
            Nice project where you can sahare your favorites pictures with
            others.
          </p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://i-share-app.netlify.app/"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={ishare}
                  style={{ width: '100%' }}
                  alt="i-share"
                  className="w3-margin-bottom item"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w3-container w3-card w3-white w3-round w3-margin cn">
          <h4 className="project_one">Crypto</h4>

          <Rule color="#49a6e9" />
          <p className="description">
            Crypto website where you can connect with metamask.
          </p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://crypto-money-app.netlify.app/"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={crypto}
                  style={{ width: '100%' }}
                  alt="crypto"
                  className="w3-margin-bottom"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w3-container w3-card w3-white w3-round w3-margin cn">
          <h4 className="project_one">Diamond</h4>

          <Rule color="#49a6e9" />
          <p className="description">Diamont Portfolio.</p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://portfolio-app-react.netlify.app/"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={diamant}
                  style={{ width: '100%' }}
                  alt="diamont"
                  className="w3-margin-bottom"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w3-container w3-card w3-white w3-round w3-margin cn">
          <h4 className="project_one">Medium Clone</h4>

          <Rule color="#49a6e9" />
          <p className="description">A small clone from the Medium website.</p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://medium-sepia.vercel.app/"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={medium}
                  style={{ width: '100%' }}
                  alt="medium"
                  className="w3-margin-bottom"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w3-container w3-card w3-white w3-round w3-margin cn">
          <h4 className="project_one">NFTs</h4>

          <Rule color="#49a6e9" />
          <p className="description">
            Nfts page where you can mint your nfts, connect to metamask.
          </p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://nft-three-ivory.vercel.app/"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={mafia}
                  style={{ width: '100%' }}
                  alt="nfts"
                  className="w3-margin-bottom"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w3-container w3-card w3-white w3-round w3-margin cn">
          <h4 className="project_one">Twitter Clone</h4>

          <Rule color="#49a6e9" />
          <p className="description">
            A clone from the Twitter, connection with google account.
          </p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://twitter-clone-two-bay.vercel.app/"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={twitter}
                  style={{ width: '100%' }}
                  alt="twitter"
                  className="w3-margin-bottom"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w3-container w3-card w3-white w3-round w3-margin cn">
          <h4 className="project_one">Airbnb Clone</h4>

          <Rule color="#49a6e9" />
          <p className="description">A small clone from the Airbnb website.</p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://airbnb-clone-ivory-three.vercel.app/"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={airbnb}
                  style={{ width: '100%' }}
                  alt="airbnb"
                  className="w3-margin-bottom"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w3-container w3-card w3-white w3-round w3-margin cn">
          <h4 className="project_one">Metaverse Chat</h4>

          <Rule color="#49a6e9" />
          <p className="description">
            Metaverse Chat, connection with metamask.
          </p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://metaverse-sandy.vercel.app/"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={metaverse}
                  style={{ width: '100%' }}
                  alt="metaverse"
                  className="w3-margin-bottom"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w3-container w3-card w3-white w3-round w3-margin cn">
          <h4 className="project_one">Instagram Clone</h4>

          <Rule color="#49a6e9" />
          <p className="description">Instagram clone.</p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://insta8-5.vercel.app/"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={instagram}
                  style={{ width: '100%' }}
                  alt="instagram"
                  className="w3-margin-bottom"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w3-container w3-card w3-white w3-round w3-margin cn">
          <h4 className="project_one">NFTs App</h4>

          <Rule color="#49a6e9" />
          <p className="description">NFTs app with React Native.</p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://expo.dev/@i-create/NFT?serviceType=classNameic&distribution=expo-go"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={bgHome}
                  style={{ width: '100%' }}
                  alt="nfts react native"
                  className="w3-margin-bottom nft-native"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="w3-container w3-card w3-white w3-round w3-margin cn">
          <h4 className="project_one">Instagram Clone </h4>

          <Rule color="#49a6e9" />
          <p className="description">Insagram Clone With React Native.</p>
          <div className="w3-row-padding projects" style={{ margin: 0 - 16 }}>
            <div className="w3-center">
              <a
                href="https://expo.dev/@i-create/instagram?serviceType=classNameic&distribution=expo-go"
                target="_blank"
                rel="noreferrer"
                title="Click here"
              >
                <img
                  src={rntinsta}
                  style={{
                    width: '100%',
                    height: '600px',
                    objectFit: 'contain',
                  }}
                  alt="nfts react native"
                  className="w3-margin-bottom nft-native"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Middle;
